import Skeleton from "@/v2-ui/skeleton"
import cn from "@/v2-ui/utils/utils.cn"

// Mirrors the real section-header + category-row layout (varying label
// widths so it doesn't read as a single repeated block) while the catalog
// query is in flight — board.categories is [] at that point, which without
// this renders as a blank gap indistinguishable from "still loading".
const CATEGORY_SKELETON_SECTIONS: {
  id: string
  rows: { id: string; widthClassName: string }[]
}[] = [
  {
    id: "ui",
    rows: [
      { id: "ui-1", widthClassName: "w-28" },
      { id: "ui-2", widthClassName: "w-20" },
      { id: "ui-3", widthClassName: "w-24" },
      { id: "ui-4", widthClassName: "w-16" },
      { id: "ui-5", widthClassName: "w-24" },
    ],
  },
  {
    id: "data",
    rows: [
      { id: "data-1", widthClassName: "w-20" },
      { id: "data-2", widthClassName: "w-28" },
      { id: "data-3", widthClassName: "w-16" },
    ],
  },
]

function TranslationSidebarCategoriesSkeleton() {
  return (
    <div aria-hidden>
      {CATEGORY_SKELETON_SECTIONS.map((section) => (
        <div key={section.id} className="translation-sidebar-section">
          <div className="translation-sidebar-section-header">
            <Skeleton className="h-3 w-16 rounded-sm bg-muted-foreground/20" />
          </div>
          {section.rows.map((row) => (
            <div key={row.id} className="translation-sidebar-item">
              <Skeleton className="size-2 shrink-0 rounded-full bg-muted-foreground/20" />
              <Skeleton
                className={cn(
                  "h-3 rounded-sm bg-muted-foreground/20",
                  row.widthClassName,
                )}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default TranslationSidebarCategoriesSkeleton
